import { useState, useEffect } from "react";
import { useLocation, useParams } from "react-router-dom";
import useGetProduct from "../common/api/useGetProduct";
import { formatDate, handleAlert } from "@utils/helperFunctions";
import ProductInfo from "../common";
import { Product } from "../common/types/Product";

const Edit = ({ allProjectVariables }) => {
  const { id } = useParams<{ id: string }>();
  const productId = Number(id);

  const { product, isLoading, isFetching, error, refetch } =
    useGetProduct(productId);

  const [productAttributes, setProductAttributes] = useState<Product>({
    id: 0,
    type: "products",
    attributes: {
      name: "",
      description: "",
      sku: "",
      intProdID: "",
      mfgPartNum: "",
      units: "",
      category: "",
      subcategory: "",
      unitPrice: 0,
      unitCost: 0,
      listPrice: 0,
      variables: allProjectVariables,
    },
  });

  useEffect(() => {
    if (!isLoading && !isFetching && product?.id) {
      setProductAttributes({
        id: product.id,
        type: "products",
        attributes: {
          name: product.attributes.name || "",
          description: product.attributes?.description || "",
          sku: product.attributes?.sku || "",
          intProdID: product.attributes?.intProdID || "",
          mfgPartNum: product.attributes?.mfgPartNum || "",
          units: product.attributes?.units || "",
          category: product.attributes?.category || "",
          subcategory: product.attributes?.subcategory || "",
          unitPrice: product.attributes?.unitPrice || 0,
          unitCost: product.attributes?.unitCost || 0,
          listPrice: product.attributes?.listPrice || 0,
          variables: product.attributes?.variables?.map((variable) => {
            if (
              variable.required &&
              (variable?.["variable-type"] === "date" ||
                variable?.["variable_type"] === "date") &&
              (!variable.value || variable.value == "")
            ) {
              variable = { ...variable, value: formatDate(new Date()) };
            }
            return variable;
          }),
        },
      });
    }
  }, [isLoading, isFetching]);

  if (!productId || isLoading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div> Error Loading Product.</div>;
  }

  return (
    <ProductInfo
      mode="edit"
      product={productAttributes}
      setProductAttributes={setProductAttributes}
      allProjectVariables={allProjectVariables}
      refetch={refetch}
    />
  );
};

export default Edit;
